import {
  Bell,
  Check,
  X,
  Bot,
  Zap,
  AlertCircle,
  Info,
  CheckCircle
} from 'lucide-react'

const NotificationDropdown = ({ onClose }) => {
  const notifications = [
    {
      id: 1,
      type: 'success',
      title: 'Chatbot Deployed Successfully',
      message: 'Your AI chatbot "Customer Support Bot" is now live and ready to handle customer queries.',
      time: '2 minutes ago',
      unread: true
    },
    {
      id: 2,
      type: 'info',
      title: 'New Feature Available',
      message: 'Multi-language support is now available for all Pro and Enterprise plans.',
      time: '1 hour ago',
      unread: true
    },
    {
      id: 3,
      type: 'warning',
      title: 'API Usage Alert',
      message: 'You\'ve used 85% of your monthly API quota. Consider upgrading your plan.',
      time: '3 hours ago',
      unread: false
    },
    {
      id: 4,
      type: 'success',
      title: 'Payment Successful',
      message: 'Your monthly subscription payment of $29 has been processed.',
      time: '1 day ago',
      unread: false
    },
    {
      id: 5,
      type: 'info',
      title: 'Weekly Report Ready',
      message: 'Your weekly analytics report is now available in the dashboard.',
      time: '2 days ago',
      unread: false
    }
  ]

  const getNotificationIcon = (type) => {
    switch (type) {
      case 'success':
        return <CheckCircle className="w-5 h-5 text-success-500" />
      case 'warning':
        return <AlertCircle className="w-5 h-5 text-warning-500" />
      case 'info':
        return <Info className="w-5 h-5 text-info-500" />
      default:
        return <Bell className="w-5 h-5 text-secondary-400" />
    }
  }

  const unreadCount = notifications.filter(n => n.unread).length

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 z-[9998]"
        onClick={onClose}
      />

      {/* Dropdown */}
      <div className="absolute right-0 mt-2 w-96 bg-secondary-800 border border-secondary-700 rounded-xl shadow-xl z-[9999]">
        {/* Header */}
        <div className="p-4 border-b border-secondary-700">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <Bell className="w-5 h-5 text-white" />
              <h3 className="text-white font-semibold">Notifications</h3>
              {unreadCount > 0 && (
                <span className="bg-primary-500 text-white text-xs px-2 py-1 rounded-full">
                  {unreadCount}
                </span>
              )}
            </div>
            <button
              onClick={onClose}
              className="p-1 rounded-lg hover:bg-secondary-700 transition-colors"
            >
              <X className="w-4 h-4 text-secondary-400" />
            </button>
          </div>
        </div>

        {/* Notifications List */}
        <div className="max-h-96 overflow-y-auto">
          {notifications.length === 0 ? (
            <div className="p-6 text-center">
              <Bell className="w-12 h-12 text-secondary-600 mx-auto mb-3" />
              <p className="text-secondary-400">No notifications yet</p>
            </div>
          ) : (
            <div className="py-2">
              {notifications.map((notification) => (
                <div
                  key={notification.id}
                  className={`px-4 py-3 hover:bg-secondary-700 transition-colors border-l-4 ${notification.unread
                    ? 'border-primary-500 bg-secondary-700/30'
                    : 'border-transparent'
                    }`}
                >
                  <div className="flex items-start space-x-3">
                    <div className="flex-shrink-0 mt-0.5">
                      {getNotificationIcon(notification.type)}
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center justify-between">
                        <h4 className="text-white font-medium text-sm">
                          {notification.title}
                        </h4>
                        {notification.unread && (
                          <div className="w-2 h-2 bg-primary-500 rounded-full flex-shrink-0"></div>
                        )}
                      </div>
                      <p className="text-secondary-400 text-sm mt-1">
                        {notification.message}
                      </p>
                      <p className="text-secondary-500 text-xs mt-2">
                        {notification.time}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Footer */}
        {notifications.length > 0 && (
          <div className="p-4 border-t border-secondary-700">
            <div className="flex items-center justify-between">
              <button className="text-primary-400 text-sm font-medium hover:text-primary-300 transition-colors">
                Mark all as read
              </button>
              <button className="text-secondary-400 text-sm hover:text-white transition-colors">
                View all notifications
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  )
}

export default NotificationDropdown
